import { useState } from "react";

import type { IDiscountsPanel, IDiscountsPanelResult } from "@/src/discount/DiscountsPanel/DiscountsPanel";
import type { IComponent } from "@Components/Component";
import { defaultAttributes } from "@Components/Component";
import { ItemTemplate, NoResultsTemplate, Repeater } from "@Components/Repeater";

import type { IContentContainer } from "../common/ContentContainer";
import ContentContainer from "../common/ContentContainer";
import type { IDiscountTile } from "../discount/DiscountTile";
import DiscountTile from "../discount/DiscountTile";
import DiscountsPanel from "../discount/DiscountsPanel";
import type { ILoyaltyCardInfo } from "../loyalty-card/LoyaltyCardInfo";
import LoyaltyCardInfo, { LoyaltyCardInfoType } from "../loyalty-card/LoyaltyCardInfo";
import type { IMomentHeader } from "./MomentHeader";
import { MomentHeader } from "./MomentHeader";

import * as cssPortal from "../shared/Portal.module.css";
import * as css from "./Moment.module.css";

export interface IMomentDetails extends IComponent {
    momentComponent: null;
    noResultText: string;
    header: IMomentHeader;
    loyaltyCardInfo?: ILoyaltyCardInfo;
    repeater?: Repeater;
    discountsPanel?: IDiscountsPanel;
    contentContainers?: IContentContainer;
}

export const MomentDetails = (props: IMomentDetails) => {
    const [state, setState] = useState({
        noResultContent: false,
        momentComponent: props.momentComponent,
        loyaltyCardInfo: props.loyaltyCardInfo,
    });

    const discountPanelSuccess = (response: IDiscountsPanelResult): void => {
        if (
            !response ||
            !response.carousels ||
            response.carousels.length === 0 ||
            !response.carousels[0].discounts ||
            response.carousels[0].discounts.length === 0
        ) {
            setState({
                momentComponent: null,
                noResultContent: true,
                loyaltyCardInfo: state.loyaltyCardInfo,
            });
        }
    };

    return (
        <div {...defaultAttributes(props, css.momentDetailsComponent)}>
            <MomentHeader {...props.header} />
            <div className={cssPortal.standardContainer}>
                {props.loyaltyCardInfo && (
                    <LoyaltyCardInfo
                        {...props.loyaltyCardInfo}
                        loyaltyCardInfoType={LoyaltyCardInfoType.AlignRight}
                    />
                )}
                {props.discountsPanel && (
                    <DiscountsPanel {...props.discountsPanel} success={discountPanelSuccess} />
                )}
                {props.repeater && (
                    <Repeater {...props.repeater}>
                        <ItemTemplate>
                            <DiscountTile {...({} as IDiscountTile)} origin={"SpecialEvent"} />
                        </ItemTemplate>
                        <NoResultsTemplate>
                            <div className={css.noData}>{props.noResultText}</div>
                        </NoResultsTemplate>
                    </Repeater>
                )}
                <ContentContainer {...props.contentContainers} />
            </div>
        </div>
    );
};
